import React, {Component} from 'react'
import { connect } from 'react-redux'

import Container from 'ui/Container'
import Button from 'ui/Button'

class OverlayPlayer extends Component{

  constructor(props){
    super(props)
  }

  render(){
    const {track} = this.props
    return (
      <div className="overlay-player">
        <div className="track-display">
          <div className="track-title">{track ? track.title : ''}</div>
          <div className="track-artist">{track ? track.artist : ''}</div>
        </div>
      </div>
    )
  }
}
function mapStateToProps(store){
  return {
    track:store.player.currTrack
  }
}
export default connect(mapStateToProps)(OverlayPlayer)


// WEBPACK FOOTER //
// ./src/components/overlay/OverlayPlayer.js